import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BadgeModule } from '@appkit4/angular-components/badge';
import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { FieldModule } from '@appkit4/angular-components/field';
import { ModalModule } from '@appkit4/angular-components/modal';
import { SingleDropdownModule } from '@appkit4/angular-components/single-dropdown';
import { TabsModule } from '@appkit4/angular-components/tabs';
import { GridModule } from '@shared/modules/grid/grid.module';
import { PrimeGridFiltersModule } from '@shared/modules/prime-grid-filters/prime-grid-filters.module';
import { RichEditorModule } from '@shared/modules/rich-editor/rich-editor.module';
import { FormatRatePipe } from '@shared/pipes/format-rate.pipe';
import { SharedModule } from '@shared/shared.module';
import { ApprovalQuestionModalComponent } from './components/approval-question-modal/approval-question-modal.component';
import { CommentFieldComponent } from './components/comment-field/comment-field.component';
import { ExplanationEditorComponent } from './components/explanation-editor/explanation-editor.component';
import { ExplanationFieldComponent } from './components/explanation-field/explanation-field.component';
import { NotificationPanelItemComponent } from './components/notification-panel-item/notification-panel-item.component';
import { NotificationPanelComponent } from './components/notification-panel/notification-panel.component';
import { RateFieldComponent } from './components/rate-field/rate-field.component';
import { RatesManagerComponent } from './components/rates-manager/rates-manager.component';
import { SettingsPanelComponent } from './components/settings-panel/settings-panel.component';
import { TaxCardComponent } from './components/tax-card/tax-card.component';
import { TaxResultCardComponent } from './components/tax-result-card/tax-result-card.component';
import { TaxResultFieldsetComponent } from './components/tax-result-fieldset/tax-result-fieldset.component';
import { TaxResultSecurityDetailsComponent } from './components/tax-result-security-details/tax-result-security-details.component';
import { YesNoComponent } from './components/yes-no/yes-no.component';
import { TaxResultAccordionListPageComponent } from './pages/tax-result-accordion-list-page/tax-result-accordion-list-page.component';
import { TaxResultPageComponent } from './pages/tax-result-page/tax-result-page.component';
import { FilterOrderRatesPipe } from './pipes/filter-order-rates.pipe';
import { TaxResultEditionService } from './services/tax-result-edition.service';
import { TaxResultRoutingModule } from './tax-result-routing-module';

const pages = [TaxResultPageComponent, TaxResultAccordionListPageComponent];

@NgModule({
  declarations: [
    FormatRatePipe,
    FilterOrderRatesPipe,
    ExplanationFieldComponent,
    CommentFieldComponent,
    NotificationPanelComponent,
    NotificationPanelItemComponent,
    RateFieldComponent,
    SettingsPanelComponent,
    TaxCardComponent,
    TaxResultSecurityDetailsComponent,
    TaxResultFieldsetComponent,
    YesNoComponent,
    ApprovalQuestionModalComponent,
    TaxResultCardComponent,
    RatesManagerComponent,
    ExplanationEditorComponent,
    ...pages,
  ],
  imports: [
    CommonModule,
    TaxResultRoutingModule,
    TabsModule,
    FieldModule,
    ModalModule,
    ReactiveFormsModule,
    CheckboxModule,
    BadgeModule,
    SingleDropdownModule,
    SharedModule,
    PrimeGridFiltersModule,
    GridModule,
    RichEditorModule,
  ],
  providers: [TaxResultEditionService],
})
export class TaxResultModule {}
